<template>
  <div class="bg-gradient-to-b from-brand-hurst-next-blue to-brand-hurst-next-blue-2 rounded-lg px-12 py-16 max-w-lg mx-auto">
    <h2 v-if="!successfullyRegistered" class="text-white text-2xl">Sign up below to get a sneak preview of what Hurst NEXT has to offer!</h2>
    <h2 v-else class="text-white text-2xl">Congratulations!</h2>
    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="">
        <form v-if="!successfullyRegistered && user === null" class="space-y-6 px-6" action="#" method="POST" @submit.prevent="submit">
          <div>
            <label for="firstName" class="block text-sm text-white font-medium"> First Name </label>
            <div class="mt-1">
              <input id="firstName" v-model="form.firstName" name="firstName" type="text" autocomplete="given-name" required
                     placeholder="Nurse"
                     class="appearance-none block w-full px-3 py-2 border border-brand-gray-300 rounded-full shadow-sm placeholder-brand-gray-600 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
              <p v-if="hasError('firstName')" class="mt-2 text-sm bg-red-600 text-white px-3 py-2 rounded-md" >{{errors['firstName'][0]}}</p>
            </div>
          </div>
          <div>
            <label for="lastName" class="block text-sm text-white font-medium"> Last Name </label>
            <div class="mt-1">
              <input id="lastName" v-model="form.lastName" name="lastName" type="text" autocomplete="family-name" required
                     placeholder="Smith"
                     class="appearance-none block w-full px-3 py-2 border border-brand-gray-300 rounded-full shadow-sm placeholder-brand-gray-600 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
              <p v-if="hasError('lastName')" class="mt-2 text-sm bg-red-600 text-white px-3 py-2 rounded-md" >{{errors['lastName'][0]}}</p>
            </div>
          </div>
          <div>
            <label for="email"class="block text-sm text-white font-medium"> Email address </label>
            <div class="mt-1">
              <input id="email" v-model="form.emailAddress" name="email" type="email" autocomplete="email" required
                     placeholder="nurse@myschoolemail.edu"
                     class="appearance-none block w-full px-3 py-2 border border-brand-gray-300 rounded-full shadow-sm placeholder-brand-gray-600 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
              <p v-if="hasError('emailAddress')" class="mt-2 text-sm bg-red-600 text-white px-3 py-2 rounded-md" >{{errors['emailAddress'][0]}}</p>
            </div>
          </div>
          <div>
            <label for="password" class="block text-sm text-white font-medium"> Password </label>
            <div class="mt-1">
              <input id="password" v-model="form.password" name="password" type="password" autocomplete="current-password" required
                     placeholder="Password"
                     class="appearance-none block w-full px-3 py-2 border border-brand-gray-300 rounded-full shadow-sm placeholder-brand-gray-600 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
              <p v-if="hasError('password')" class="mt-2 text-sm bg-red-600 text-white px-3 py-2 rounded-md" >{{errors['password'][0]}}</p>
            </div>
          </div>
          <div>
            <label for="confirm_password" class="block text-sm text-white font-medium"> Confirm Password </label>
            <div class="mt-1">
              <input id="confirm_password" v-model="form.confirm_password" name="confirm_password" type="password" required
                     placeholder="Password"
                     class="appearance-none block w-full px-3 py-2 border border-brand-gray-300 rounded-full shadow-sm placeholder-brand-gray-600 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
              <p v-if="hasError('confirm_password')" class="mt-2 text-sm bg-red-600 text-white px-3 py-2 rounded-md" >{{errors['confirm_password'][0]}}</p>
            </div>
          </div>
          <div>
            <label for="degreeType" class="block text-sm text-white font-medium"> Degree Program </label>
            <div class="mt-1">
              <select id="degreeType" v-model="form.degreeType" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-brand-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-full">
                <option :value="null" disabled>Please select a degree program</option>
                <option value="BSN">BSN</option>
                <option value="ADN">ADN</option>
                <option value="PN">LPN</option>
              </select>
              <p v-if="hasError('degreeType')" class="mt-2 text-sm bg-red-600 text-white px-3 py-2 rounded-md" >{{errors['degreeType'][0]}}</p>
            </div>
          </div>
          <div>
            <label for="nursingSchool" class="block text-sm text-white font-medium"> Nursing School </label>
            <div class="mt-1 relative">
              <input id="nursingSchool" name="nursingSchool" type="text" required
                     placeholder="University of Awesome Nurses"
                     v-model="query"
                     @keydown="keydown"
                     class="appearance-none block w-full px-3 py-2 border border-brand-gray-300 rounded-full shadow-sm placeholder-brand-gray-600 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
              <p v-if="hasError('schoolId')" class="mt-2 text-sm bg-red-600 text-white px-3 py-2 rounded-md" >{{errors['schoolId'][0]}}</p>
              <div class="absolute w-full px-4 " v-if="showResults" ref="results">
                <ul v-if="schoolResults.length > 0" class="border border-brand-gray-400 bg-white h-[200px] overflow-x-auto">
                  <li v-for="(school,schoolIdx) in schoolResults" class="px-2 py-3 text-sm text-brand-gray-600 hover:bg-blue-800 hover:text-white"
                      :class="{
                          'bg-brand-gray-100': schoolIdx %2 !== 0,
                          'bg-blue-800 text-white': schoolIdx === arrowCounter
                      }">
                    <a href="#" @click.prevent="selectSchool(school)">{{school.schoolName}} - {{school.schoolCity}}, {{school.schoolState}}</a>
                  </li>
                </ul>
                <div v-else class="border border-brand-gray-400 bg-white overflow-x-auto">
                  <span class="px-2">No Results for search term.</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <fieldset class="grid grid-cols-5">
              <legend class="block text-sm text-white font-medium">Expected Graduation</legend>
              <label for="grad_month" class="sr-only">Graduation Month</label>
              <input type="number" v-model.number="form.graduationMonth" id="grad_month" class="mt-1 col-span-2 appearance-none block w-full px-3 py-2 border border-brand-gray-300 rounded-full shadow-sm placeholder-brand-gray-600 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" min="01" max="12" placeholder="MM" required>
              <div class="mt-1 text-center text-white font-medium flex flex-col justify-center">/</div>
              <label for="grad_year" class="sr-only">Graduation Year</label>
              <input type="number" v-model.number="form.graduationYear" id="grad_year" class="mt-1 col-span-2 appearance-none block w-full px-3 py-2 border border-brand-gray-300 rounded-full shadow-sm placeholder-brand-gray-600 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" min="2021" max="2030" placeholder="YYYY" required>
            </fieldset>
            <p v-if="hasError('graduationMonth')" class="mt-2 text-sm bg-red-600 text-white px-3 py-2 rounded-md">{{errors['graduationMonth'][0]}}</p>
            <p v-if="hasError('graduationYear')" class="mt-2 text-sm bg-red-600 text-white px-3 py-2 rounded-md">{{errors['graduationYear'][0]}}</p>
          </div>
          <div>
            <button type="submit"
                    class="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500">
              Create My Free Trial Account
            </button>
          </div>
        </form>
        <div v-else-if="!successfullyRegistered && user !== null && user.isNextUser">
          <p class="text-white text-xl font-medium">
            It looks like you are already logged into a Hurst Review account that has access to Hurst Next. This promotion is for
            students who do not currently have access to this content.
          </p>
        </div>
        <div v-else>
          <p class="text-white text-xl font-medium">Your Hurst Next account has been created. Please <a href="/my-account" class="underline">Login Now</a> to access your content.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {debounce} from 'lodash';

export default {
  name: "HurstNextPromoRegistration",

  props: {
    user: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      arrowCounter: -1,
      form: {
        confirm_password: null,
        emailAddress: null,
        degreeType: null,
        firstName: null,
        graduationMonth: null,
        graduationYear: null,
        lastName: null,
        password: null,
        schoolId: null
      },
      errors: {},
      query: '',
      schoolResults: [],
      showResults: false,
      school: null,
      successfullyRegistered: false
    }
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },

  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  },

  watch: {

  },

  methods: {
    handleClickOutside(event) {
      if (this.showResults && !this.$refs.results.contains(event.target)) {
        this.showResults = false;
        this.arrowCounter = -1;
      }
    },

    hasError(field) {
      return this.errors.hasOwnProperty(field);
    },

    keydown(event) {
      switch(event.code) {
        case 'ArrowDown':
          this.onArrowDown();
          break;
        case 'ArrowUp':
          this.onArrowUp();
          break;
        case 'Escape':
          this.showResults=false;
          break;
        case 'Enter':
          this.onEnter();
          event.preventDefault();
          break;
        default:
          this.search()
      }
    },

    onArrowDown() {
      if (this.arrowCounter < this.schoolResults.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      if (this.showResults) {
        this.selectSchool(this.schoolResults[this.arrowCounter])
        this.showResults = false;
      }
    },
    search: debounce(async function () {
      if (this.query.length > 0) {
        const resp = await axios.get(`/ajax/school/${this.query}`);
        this.schoolResults = resp.data;
        this.showResults = true;
      }else {
        this.schoolResults = [];
        this.showResults = false;
      }
    }, 300),

    selectSchool(school) {
      this.school = school;
      this.form.schoolId = school.schoolId;
      this.arrowCounter = -1;
      this.query = school.schoolName;
      this.showResults = false
    },

    async submit() {
      this.errors = {};
      try {
        const resp = await axios.post('/api/hurst-next-promo-registration', this.form);
        this.successfullyRegistered = true
      }catch(e) {
        if(e.response.status === 422) {
          this.errors = e.response.data;
        }
      }
    }
  }
}
</script>

<style scoped>

</style>